import { ChevronLeft, ChevronRight } from "lucide-react"
import { useState } from "react";
import { useTranslate } from "sbx-crm-menu-ui";
import { DocumentV2Response } from "src/types/DocumentOrImageV2";
import MarkdownPreview from '@uiw/react-markdown-preview';

interface Props {
    numPages: number;
    document: DocumentV2Response;
    loading: boolean;
}

export const SourcesAnswerComponent = ({ numPages, document, loading }:Props) => {
    const [pageNumber, setPageNumber] = useState<number>(1);
    const { t: documentT } = useTranslate('document');
    const { t: common } = useTranslate('common');
    const { t: agent } = useTranslate('agent');

    const handleNextPage = () => {
        if (pageNumber < numPages) {
            setPageNumber(pageNumber + 1);
        }
    };

    const handlePreviousPage = () => {
        if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    };
  return (
    <div className="flex flex-col max-h-[85vh]">
        {
            document.message ? (
                <>
                    <div className="flex justify-between pb-5">
                        <div className="flex flex-col gap-1">
                        {
                            document.sources[pageNumber - 1] && (
                                <>
                                <p>{document.sources[pageNumber - 1].metadata.source?.split('/').pop()}</p>
                                {
                                    document.sources[pageNumber - 1].metadata.page !== undefined && document.sources[pageNumber - 1].metadata.page !== null && (
                                        <p>{documentT("page")+': '}{(document.sources[pageNumber - 1].metadata.page || 0) + 1}</p>
                                    )
                                }
                                
                                </>
                            )
                        }
                        </div>
                        <div className="flex items-center gap-1 justify-center">
                            <ChevronLeft onClick={handlePreviousPage} className="cursor-pointer" />
                            <p>
                                {documentT("ai_document")} {pageNumber} {common("of")} {numPages}
                            </p>
                            <ChevronRight onClick={handleNextPage} className="cursor-pointer" />
                        </div>
                    </div>

                    <div className="w-auto overflow-auto">
                        <MarkdownPreview
                            className="shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-white"
                            source={document.sources[pageNumber - 1].page_content.replaceAll("```markdown\n", "").replaceAll("```", "").replaceAll(/\n/g, '<br />')} 
                        />
                    </div>
                </>
            )
            :
            (
              <p className="text-center text-gray-400">{loading ? agent('processing') + '...' : agent('no_sources')}</p> 
            )
        }
    </div>
  )
}
